
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-miterlimit":"10","stroke-width":"2","d":"M30.47 45.92c-3.19 0-6.08-1.32-8.14-3.7-1.07-1.24-1.84-2.54-2.35-3.97-.54-1.5-.8-3.15-.8-5.04 0-1.89.26-3.89.74-5.84.51-2.03 1.23-3.89 2.1-5.37.98-1.65 2.12-2.99 3.41-3.96.74-.56 1.52-.99 2.32-1.29.89-.33 1.8-.5 2.72-.5.92 0 1.83.17 2.72.5.8.3 1.58.73 2.32 1.29 1.29.97 2.44 2.3 3.41 3.96.87 1.48 1.6 3.34 2.1 5.37.48 1.95.74 3.98.74 5.84 0 1.86-.26 3.54-.8 5.04-.52 1.43-1.29 2.73-2.35 3.97-2.06 2.39-4.95 3.7-8.14 3.7z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-miterlimit":"10","stroke-width":"2","d":"M37.97 20.56c.07-.13.15-.26.22-.39m0 0c.88-1.49 1.91-2.69 3.07-3.56.66-.5 1.36-.89 2.08-1.16.8-.3 1.62-.45 2.45-.45.83 0 1.65.15 2.45.45.72.27 1.42.66 2.08 1.16 1.16.87 2.19 2.07 3.07 3.56.78 1.33 1.44 3 1.89 4.83.43 1.76.66 3.58.66 5.25s-.23 3.18-.72 4.53c-.46 1.29-1.16 2.46-2.12 3.57-1.85 2.15-4.45 3.33-7.32 3.33-2.06 0-3.98-.61-5.58-1.75m-19.46.01c-1.61 1.14-3.53 1.75-5.58 1.75-2.87 0-5.46-1.18-7.32-3.33-.96-1.11-1.65-2.28-2.12-3.57-.48-1.35-.72-2.83-.72-4.53 0-1.7.23-3.5.66-5.25.45-1.83 1.11-3.5 1.89-4.83.88-1.49 1.91-2.69 3.07-3.56.66-.5 1.36-.89 2.08-1.16.8-.3 1.62-.45 2.45-.45.83 0 1.65.15 2.45.45.72.27 1.42.66 2.08 1.16 1.16.87 2.19 2.07 3.07 3.56.07.13.15.26.22.39"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M8.12 30.87c0 1.15.39 5.06 4.41 7.21m9.94-3.83c0 1.15.39 5.06 4.41 7.21"}})])
          )
        }
      }
    